import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { DeclaracionComponent} from '../declaracion/declaracion.component'
import { AuthenticatedHttpService } from '../interceptor/interceptor'
import { Http } from '@angular/http'
import { ErrorsComponent } from '../errors/errors.component'

const routes: Routes = [
  { path: 'declaracion',  component: DeclaracionComponent },
  { path: 'error/:type',  component: ErrorsComponent }
]

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers: [
    { provide: Http, useClass: AuthenticatedHttpService }
  ]
})
export class RoutingModule {}



// WEBPACK FOOTER //
// ./src/app/modules/routing.module.ts